import { createSelector } from 'reselect';
import { RootState } from 'typesafe-actions';

import { HotelList } from 'HotelList-Types';
import { HotelListState } from './reducer';

export const getHotelList = (state: RootState) => state.hotelList;

export const getHotels = createSelector(getHotelList, (state: HotelListState) => state.hotels);
export const getPrefetchedFilters = createSelector(getHotelList, (state: HotelListState) => ({
  filters: state.prefetchedHotels.filters,
  total: state.prefetchedHotels.total,
}));

export const hasMoreHotel = createSelector(getHotels, (hotels: HotelList) => {
  const { offset, total, limit } = hotels;
  return total > offset + limit;
});

export const getHotelListBreadcrumb = createSelector(
  getHotels,
  ({ breadcrumb }) => breadcrumb || [],
);

export const getHotelListMapBreadcrumb = createSelector(
  getHotels,
  ({ breadcrumb }) => breadcrumb || [],
);

export const getIsFetching = createSelector(
  getHotelList,
  (state: HotelListState) => state.isFetchingList,
);

export const getIsFetchingFilters = createSelector(
  getHotelList,
  (state: HotelListState) => state.isFetchingFilters,
);

export const getIsFirstTimeLoading = createSelector(
  getHotelList,
  (state: HotelListState) =>
    typeof state.isFirstTimeLoading === 'object' || state.isFirstTimeLoading,
);

export const getIsFetchingMoreHotels = createSelector(
  getHotelList,
  (state: HotelListState) => state.isFetchingMoreHotels,
);
